<form [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit()">
  <orbit-form-field
    [inputType]="'email'"
    [label]="'E-mail'"
    [name]="'email'"
    [controller]="email" />
  <div class="login-error">{{ errorMessage }}</div>
  <orbit-button
    [label]="'SHARED.PASSWORD_RESET.SEND_PASSWORD_RESET_LINK' | translate"
    [inputId]="'reset-password-button'"
    type="submit"
    class="w-full"
    styleClass="w-full"
    size="large" />
  <orbit-button
    [label]="'SHARED.PASSWORD_RESET.GO_TO_LOGIN' | translate"
    [inputId]="'back-to-login'"
    type="button"
    [flat]="true"
    (buttonClick)="goToLogin()" />
</form>
